import TruncatedConeGeometry from './truncated-cone-geometry';
import { uid } from '@luma.gl/webgl';
export default class ConeGeometry extends TruncatedConeGeometry {
  constructor() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      id = uid('cone-geometry'),
      radius = 1,
      cap = true
    } = props;
    super({ ...props,
      id,
      topRadius: 0,
      topCap: Boolean(cap),
      bottomCap: Boolean(cap),
      bottomRadius: radius
    });
  }

}
//# sourceMappingURL=cone-geometry.js.map


// WEBPACK FOOTER //
// ./~/@luma.gl/engine/dist/esm/geometries/cone-geometry.js